// 法人情報編集履歴
import React, { useState, useEffect } from 'react';
import { render } from 'react-dom';
import { Button } from 'react-bootstrap';
import axios from '../../../axios';
import { handleBrowserBack } from '../../../BrowserBack';
import { isBrowserIe } from '../../../BrowserJudgment';
import { api_response_type, approval_status } from '../../../Const';
import { ResponseHistoryType, UsersLabelType } from '../../../types/Corporate';
import { UsersLabel } from '../../../const/Corporate';
import LoadingModal from '../../../molecules/LoadingModal';
import CorporateCreateDefinitionList from '../../../organisms/CorporateCreateDefinitionList';
import CorporateCreateHistoryDetails from '../../../organisms/CorporateCreateHistoryDetails';
import { KWMNTGM05080A01 } from '../../../const/api_modules';
import { CorporationInfoFormatValue } from '../../../Common';
import { ItemKey } from '../../../const/Corporate';

const CorporateInfoEditHistory = () => {
  const [histories, setHistories] = useState<ResponseHistoryType[] | undefined>(undefined);
  // ローディング画面表示制御
  const [is_loading, setIsLoading] = useState(false);
  // URLパラメータの取得
  const url_params = new URLSearchParams(document.location.search.substring(1));
  const corporate_id = url_params.get('corporate_id');

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
    // 表示するデータを取得
    getData();
  }, []);

  // 表示するデータを取得
  const getData = async () => {
    try {
      // ローディング画面表示
      setIsLoading(true);

      const detail = [{ id: 0, name: 'id', value: corporate_id }];

      const response = await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/api/common`, {
        module_name : KWMNTGM05080A01,
        is_json : true,
        reception_id : '0',
        reception_cd : null,
        detail : detail,
      });

      if (response.data.response_type === api_response_type.auto_input)
        // listの中身をstateにセット
        setHistories(response.data.detail.list);
    } catch (error) {
      console.error(error.response.message);
      alert(error.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * 承認ステータスを数値から文字列に変換する処理
   */
  const convertApprovalStatusToString = (status: number) => {
    if (status === approval_status.unapproved) return '未承認';
    if (status === approval_status.approved) return '承認';
    if (status === approval_status.send_back) return '差戻し';
  };

  /**
   * 【戻る】ボタン押下時の処理
   */
  const backTransition = () => {
    if (isBrowserIe()) {
      const node = document.getElementById('corporate-info-edit-history');
      location.replace(node?.dataset.referer as string);
    } else {
      location.replace(document.referrer);
    }
  };

  return (
    <div className="corporate">
      <div className="title">法人情報</div>
      <div className="container">
        <div className="contents">
          <p className="contents_title mb-5">法人情報編集履歴</p>
          {histories &&
            Object.values(histories).map((item: ResponseHistoryType, index) => {
              return (
                <div className="border_group_wrapper" key={index}>
                  <div className="section">
                    <CorporateCreateDefinitionList
                      label="承認ステータス"
                      status={convertApprovalStatusToString(item.approval_status)}
                    />
                  </div>
                  <div className="section">
                    <CorporateCreateDefinitionList label="登録日" value={CorporationInfoFormatValue(item.updated_at, ItemKey.updated_at)} />
                    <CorporateCreateDefinitionList label="登録者" value={item.update_user_name} />
                    <CorporateCreateDefinitionList label="承認日" value={CorporationInfoFormatValue(item.approval_date, ItemKey.updated_at)} />
                    <CorporateCreateDefinitionList label="承認者" value={item.authorizer_name} />
                  </div>
                  <div className="section">
                    <CorporateCreateDefinitionList label="編集コメント" value={item.comment} />
                  </div>
                  <div className="section">
                    <p className="section_label">法人情報</p>
                    <CorporateCreateHistoryDetails type="corporate" info={item} />
                  </div>
                  {UsersLabel.map((user: UsersLabelType) => (
                    <div className="section" key={user.type}>
                      <p className="section_label">{user.label}</p>
                      <CorporateCreateHistoryDetails type={user.type} info={item} />
                    </div>
                  ))}
                </div>
              );
            })}
          <div className="d-flex justify-content-center">
            <Button
              className="btn btn-mini btn-text-color mb-4"
              variant="outline-success"
              onClick={backTransition}
            >
              戻る
            </Button>
          </div>
        </div>
      </div>
      <LoadingModal show={is_loading} />
    </div>
  );
};

if (document.getElementById('corporate-info-edit-history')) {
  render(<CorporateInfoEditHistory />, document.getElementById('corporate-info-edit-history'));
}
